export default function () {
    // ------------------------------
    // BaseApp
    // ------------------------------

    function getSentryDsn(): string {
        const value = process.env.SENTRY_FRONTEND_DSN ?? null

        if (typeof value !== 'string') {
            throw new Error(`Missing env variable 'SENTRY_FRONTEND_DSN'`)
        }

        return value
    }

    function getAppDomain(): string {
        const domain = process.env.APP_DOMAIN ?? null
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof domain !== 'string') {
            throw new Error(`Missing env variable 'APP_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${domain}`
    }

    function getLandingPageDomain(): string {
        const domain = process.env.LANDING_PAGE_DOMAIN ?? null
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof domain !== 'string') {
            throw new Error(`Missing env variable 'LANDING_PAGE_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${domain}`
    }

    function getBlogDomain(): string {
        const domain = process.env.BLOG_DOMAIN ?? null
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof domain !== 'string') {
            throw new Error(`Missing env variable 'BLOG_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${domain}`
    }

    function getCookieConsentDomain(): string {
        const cookieConsentDomain = process.env.COOKIE_CONSENT_DOMAIN ?? null
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof cookieConsentDomain !== 'string') {
            throw new Error(`Missing env variable 'COOKIE_CONSENT_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${cookieConsentDomain}`
    }

    function getHelpCenterDomain(): string {
        const domain = process.env.HELP_CENTER_DOMAIN ?? null
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof domain !== 'string') {
            throw new Error(`Missing env variable 'HELP_CENTER_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${domain}`
    }

    // ------------------------------
    // App
    // ------------------------------

    function getBookingFormDomain(): string {
        // @ts-ignore
        const bookingFormDomain = process.env.BOOKING_FORM_DOMAIN ?? null
        // @ts-ignore
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof bookingFormDomain !== 'string') {
            throw new Error(`Missing env variable 'BOOKING_FORM_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${bookingFormDomain}`
    }

    function getCustomerDomain(): string {
        // @ts-ignore
        const customerDomain = process.env.CUSTOMER_DOMAIN ?? null
        // @ts-ignore
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof customerDomain !== 'string') {
            throw new Error(`Missing env variable 'CUSTOMER_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${customerDomain}`
    }

    function getMeetingDomain(): string {
        // @ts-ignore
        const meetingDomain = process.env.MEETING_DOMAIN ?? null
        // @ts-ignore
        const httpScheme = process.env.HTTP_SCHEME ?? null

        if (typeof meetingDomain !== 'string') {
            throw new Error(`Missing env variable 'MEETING_DOMAIN'`)
        }

        if (typeof httpScheme !== 'string') {
            throw new Error(`Missing env variable 'HTTP_SCHEME'`)
        }

        return `${httpScheme}://${meetingDomain}`
    }

    return {
        // BaseApp
        getSentryDsn,
        getAppDomain,
        getLandingPageDomain,
        getBlogDomain,
        getCookieConsentDomain,
        getHelpCenterDomain,

        // App
        getBookingFormDomain,
        getCustomerDomain,
        getMeetingDomain,
    }
}
